export default function() {
  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
  }, 500)
}
